/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useEffect } from 'react'
import {
  Input,
  InputNumber,
  Form,
  Row,
  Col,
  Select,
  DatePicker,
  Switch,
} from 'antd'
import moment from 'moment'
import {
  WEE_CLIENT,
  BROOKFIELD_CLIENT,
  NYISO_CLIENT,
  CPS_CLIENT,
  CALPLINE_CLIENT,
  CLECO,
  LANYARD_CLIENT,
  NE_NEW_ENGLAND,
} from 'client'
import { APS_CLIENT } from '../../../client'
import { connect } from 'react-redux'
import { getPermitActions } from 'core/selectors'
import { hasAccesPermits } from '../../../core/utils'
import { UNITS_SHOW_PNODEID } from '../../../core/EventActions'
import { copuSelection } from '../unit'

const [DATE_FORMAT_UI, DATE_FORMAT_API] = ['MM/DD/YYYY', 'YYYY-MM-DD']

const { Option } = Select

// const UNITID_EXIST_MSG = 'Resource Id already there'

// eslint-disable-next-line no-unused-vars
const getFormSwitch = ({ label, ident, initialValue, updateUnit, unit }) => {
  return (
    <Form.Item label={label + ' :'}>
      <Switch
        checkedChildren="Y"
        unCheckedChildren="N"
        checked={initialValue === 'Y'}
        name={ident}
        onChange={checked => {
          updateUnit(ident, checked ? 'Y' : 'N')
        }}
      />
    </Form.Item>
  )
}

const getFormInput = ({
  label,
  ident,
  initialValue,
  updateUnit,
  getFieldDecorator,
  maxLength,
  isRequired,
  customValidator,
}) => {
  const rules = []
  isRequired && rules.push({ required: true, message: `Please Enter ${label}` })
  customValidator && rules.push({ validator: customValidator })

  return (
    <Form.Item label={`${label} :`}>
      {getFieldDecorator(ident, {
        initialValue: initialValue || '',
        rules,
      })(
        <Input
          placeholder={`Enter ${label}`}
          name={ident}
          maxLength={maxLength || 20}
          onChange={e => updateUnit(ident, e.target.value)}
        />
      )}
    </Form.Item>
  )
}

const getFormInputNumber = ({
  label,
  ident,
  initialValue,
  updateUnit,
  getFieldDecorator,
  min = 0,
  max = 9999999999,
  isRequired,
  customValidator,
}) => {
  const rules = []
  isRequired && rules.push({ required: true, message: 'Please Enter ' + label })
  customValidator && rules.push({ validator: customValidator })

  return (
    <Form.Item label={label + ' :'}>
      {getFieldDecorator(ident, {
        initialValue: initialValue || '',
        rules: rules,
      })(
        <InputNumber
          style={{ width: '100%' }}
          placeholder={'Enter ' + label}
          name={ident}
          min={min}
          max={max}
          onChange={value => updateUnit(ident, value)}
        />
      )}
    </Form.Item>
  )
}

const getFormDatePicker = ({
  label,
  ident,
  initialValue,
  updateUnit,
  getFieldDecorator,
  isRequired,
  customValidator,
}) => {
  const rules = []
  isRequired &&
    rules.push({ required: true, message: 'Please Select  ' + label })
  customValidator && rules.push({ validator: customValidator })

  return (
    <Form.Item label={label + ' :'}>
      {getFieldDecorator(ident, {
        initialValue: initialValue && moment(initialValue),
        rules: rules,
      })(
        <DatePicker
          style={{ display: 'block' }}
          format={DATE_FORMAT_UI}
          name={ident}
          onChange={date => {
            if (date) updateUnit(ident, date && date.format(DATE_FORMAT_API))
            else updateUnit(ident, null)
          }}
        />
      )}
    </Form.Item>
  )
}

const getFormSelect = ({
  label,
  ident,
  id,
  initialValue,
  updateUnit,
  getFieldDecorator,
  optionList,
  optionKeyGetter,
  optionValueGetter,
  isRequired,
  customValidator,
}) => {
  const rules = []
  isRequired &&
    rules.push({ required: true, message: 'Please Select ' + label })
  customValidator && rules.push({ validator: customValidator })

  return (
    <Form.Item label={label + ' :'}>
      {getFieldDecorator(ident, {
        initialValue: initialValue,
        rules: rules,
      })(
        <Select
          id={id}
          name={ident}
          onChange={value => {
            if (value === '[]') updateUnit(ident, '')
            else updateUnit(ident, value)
          }}
          showSearch
        >
          {!isRequired && <Select.Option value="[]">[]</Select.Option>}
          {optionList.map(item => (
            <Option key={optionKeyGetter(item)}>
              {optionValueGetter(item)}
            </Option>
          ))}
        </Select>
      )}
    </Form.Item>
  )
}

const UnitModalFormGeneral = props => {
  const {
    unitFormGeneralRef,

    unit,
    // unitList,
    setUnit,
    form,
    unitTypes,
    // designSeries,

    timeZones,
    // unitState,
    // controlAreas,
    // series,
    utilityNameMap,
    stationType,
    ruleSetTypes,
    loadCharTypes,
    fuelCodeDataList,
    CLIENT,
    actionPermits,
  } = props
  const { getFieldDecorator } = form

  useEffect(() => {
    unitFormGeneralRef.current = form
    // set form value incase of update, load time only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const validateUnitId = (rule, value, callback) => {
  //   if (unitList.includes(value)) {
  //     callback(UNITID_EXIST_MSG)
  //   }
  //   callback()
  // }

  const updateUnit = (property, value) => {
    setUnit(unit => {
      return { ...unit, [property]: value }
    })
  }

  const showPnodeIds = hasAccesPermits({
    actionPermits,
    eventActions: [UNITS_SHOW_PNODEID],
    matchAny: true,
  })

  return (
    <Form layout="vertical">
      <Row gutter={20}>
        <Col span={6}>
          {getFormSelect({
            label: 'Utility',
            ident: 'utility',
            // id: 'utility',
            initialValue: unit.utility,
            optionList: Object.keys(utilityNameMap)
              .sort((a, b) =>
                utilityNameMap[a].localeCompare(utilityNameMap[b])
              )
              .map(i => {
                return { utility: i, utilityName: utilityNameMap[i] }
              }),
            optionKeyGetter: item => item.utility,
            optionValueGetter: item => item.utility + '-' + item.utilityName,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>
        <Col span={4}>
          {getFormInput({
            label: 'Unit Code',
            ident: 'unit',
            initialValue: unit.unit,
            updateUnit,
            getFieldDecorator,
            maxLength: 3,
            isRequired: true,
          })}
        </Col>
        <Col span={4}>
          {getFormInput({
            label: 'Unit Name',
            ident: 'unitName',
            initialValue: unit.unitName,
            updateUnit,
            getFieldDecorator,
            maxLength: 40,
            isRequired: true,
          })}
        </Col>
        <Col span={4}>
          {getFormInput({
            label: 'Short Name',
            ident: 'shortName',
            initialValue: unit.shortName,
            updateUnit,
            maxLength: 8,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormDatePicker({
            label: 'Commencement Date',
            ident: 'commissionDate',
            initialValue: unit.commissionDate,
            updateUnit,
            maxLength: 4000,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={2}>
          {getFormSwitch({
            label: CLIENT === NYISO_CLIENT ? 'Inactive' : 'Retired',
            ident: 'retired',
            initialValue: unit.retired,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
            unit,
          })}
        </Col>

        <Col span={4}>
          {getFormDatePicker({
            label: CLIENT === NYISO_CLIENT ? 'Inactive Date' : 'Retired Date',
            ident: 'retiredDate',
            initialValue: unit.retiredDate,
            updateUnit,
            getFieldDecorator,
            isRequired: unit.retired === 'Y',
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Station',
            ident: 'station',
            id: 'station',
            initialValue: unit.station,
            optionList: Object.keys(stationType).map(i => {
              return { key: i, value: i + '-' + stationType[i] }
            }),
            optionKeyGetter: item => item.key,
            optionValueGetter: item => item.value,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
          })}
        </Col>
        <Col span={4}>
          {(CLIENT === NYISO_CLIENT ? getFormSelect : getFormInput)({
            label: CLIENT === NYISO_CLIENT ? 'CO-PU Allowed' : 'EMS ID',
            ident: 'emsId',
            initialValue: unit.udrTemp,
            updateUnit,
            getFieldDecorator,
            maxLength: 255,
            isRequired: false,
            optionList: Object.keys({ 'CO-PU': 'CO-PU' }).map(i => {
              return { id: i, display: copuSelection[i] }
            }),
            optionKeyGetter: item => item.id,
            optionValueGetter: item => item.display,
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Unit Type',
            ident: 'id1',
            id: 'unitTypeCode',
            initialValue: unit.unitTypeCode,
            optionList: Object.keys(unitTypes).map(i => {
              return { id: i, display: unitTypes[i] }
            }),
            optionKeyGetter: item => item.id,
            optionValueGetter: item => item.display,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormInput({
            label: CLIENT === NE_NEW_ENGLAND ? 'NERC Class ID' : 'Spare ID 1',
            ident: 'id3',
            initialValue: unit.id3,
            updateUnit,
            getFieldDecorator,
            maxLength: 200,
            isRequired: false,
          })}
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={4}>
          {getFormInput({
            label:
              CLIENT === WEE_CLIENT ||
              CLIENT === NYISO_CLIENT ||
              CLIENT === CPS_CLIENT ||
              CLIENT === CALPLINE_CLIENT
                ? 'Spare ID 2'
                : CLIENT === LANYARD_CLIENT
                ? 'CC Block ID'
                : 'Block ID',
            ident: 'id4',
            initialValue: unit.id4,
            updateUnit,
            getFieldDecorator,
            maxLength: 20,
            isRequired: false,
          })}
        </Col>

        <Col span={4}>
          {(CLIENT === NYISO_CLIENT ||
            CLIENT === CALPLINE_CLIENT ||
            CLIENT === CLECO ||
            CLIENT === LANYARD_CLIENT
            ? getFormInput
            : getFormSwitch)({
            label:
              CLIENT === WEE_CLIENT ||
              CLIENT === NYISO_CLIENT ||
              CLIENT === CPS_CLIENT ||
              CLIENT === CALPLINE_CLIENT ||
              CLIENT === CLECO
                ? 'Spare ID 3'
                : CLIENT === LANYARD_CLIENT
                ? 'Spare ID 2'
                : 'Track Hydro Event',
            ident: 'rStationCode',
            initialValue: unit.rStationCode,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
            unit,
          })}
        </Col>

        <Col span={4}>
          {CLIENT === WEE_CLIENT ||
          CLIENT === BROOKFIELD_CLIENT ||
          CLIENT === APS_CLIENT ||
          CLIENT === NYISO_CLIENT ||
          CLIENT === CPS_CLIENT ||
          CLIENT === CALPLINE_CLIENT ||
          CLIENT === CLECO ||
          CLIENT === LANYARD_CLIENT ||
          CLIENT === NE_NEW_ENGLAND
            ? getFormInput({
                label:
                  CLIENT === WEE_CLIENT ||
                  CLIENT === BROOKFIELD_CLIENT ||
                  CLIENT === APS_CLIENT ||
                  CLIENT === CPS_CLIENT ||
                  CLIENT === CALPLINE_CLIENT
                    ? 'Block Id'
                    : CLIENT === NYISO_CLIENT
                    ? 'Spare ID 4'
                    : CLIENT === CLECO || CLIENT === NE_NEW_ENGLAND
                    ? 'Spare ID 2'
                    : CLIENT === LANYARD_CLIENT
                    ? 'Spare ID 3'
                    : 'Track Gross Values',
                ident: 'runItCode',
                initialValue: unit.runItCode,
                updateUnit,
                getFieldDecorator,
                isRequired: false,
              })
            : getFormSwitch({
                label: 'Track Gross Values',
                ident: 'runItCode',
                initialValue: unit.runItCode,
                updateUnit,
                getFieldDecorator,
                isRequired: false,
                unit,
              })}
        </Col>

        <Col span={3}>
          {getFormSwitch({
            label: 'Send to NERC',
            ident: 'id2',
            initialValue: unit.id2,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
            unit,
          })}
        </Col>

        <Col span={3}>
          {getFormSwitch({
            label: 'Track Reserve Events',
            ident: 'rsRequired',
            initialValue: unit.rsRequired,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
            unit,
          })}
        </Col>

        <Col span={2}>
          {getFormSwitch({
            label: 'Track Daily Detail',
            ident: 'dailyDetail',
            initialValue: unit.dailyDetail,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
          })}
        </Col>

        <Col span={3}>
          {getFormSwitch({
            label: 'Daylight Saving',
            ident: 'daylightSavings',
            initialValue: unit.daylightSavings,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
            unit,
          })}
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={4}>
          {getFormSelect({
            label: 'Rule Set',
            ident: 'ruleSet',
            id: 'ruleSet',
            initialValue: unit.ruleSet,
            optionList: Object.keys(ruleSetTypes).map(i => {
              return { key: i, value: ruleSetTypes[i] }
            }),
            optionKeyGetter: item => item.key,
            optionValueGetter: item => item.value,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Time Zone',
            ident: 'timeZone',
            id: 'timeZone',
            initialValue: unit.timeZone,
            optionList: Object.keys(timeZones).map(i => {
              return { key: i, value: timeZones[i] }
            }),
            optionKeyGetter: item => item.key,
            optionValueGetter: item => item.value,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormInputNumber({
            label: 'Summer Net Max Cap',
            ident: 'netMaxCapSum',
            initialValue: unit.netMaxCapSum,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormInputNumber({
            label: 'Winter Net Max Cap',
            ident: 'netMaxCapWin',
            initialValue: unit.netMaxCapWin,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormInputNumber({
            label: 'Summer Installed Cap',
            ident: 'instCapSum',
            initialValue: unit.instCapSum,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormInputNumber({
            label: 'Winter Installed Cap',
            ident: 'instCapWin',
            initialValue: unit.instCapWin,
            updateUnit,
            getFieldDecorator,
            isRequired: true,
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Loading Characteristics',
            ident: 'loadingChar',
            initialValue: unit.loadingChar,
            optionList: Object.keys(loadCharTypes).map(i => {
              return { key: i, value: loadCharTypes[i] }
            }),
            optionKeyGetter: item => item.key,
            optionValueGetter: item => item.value,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Primary Fuel',
            ident: 'primaryFuel',
            initialValue: unit.primaryFuel,
            // optionList: Object.keys(fuelCodes).map(i => {
            //   return { code: fuelCodes[i] }
            // }),
            optionList: fuelCodeDataList,
            optionKeyGetter: item => item.code,
            optionValueGetter: item => item.code + ' - ' + item.description,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Secondary Fuel',
            ident: 'secondaryFuel',
            initialValue: unit.secondaryFuel,
            // optionList: Object.keys(fuelCodes).map(i => {
            //   return { code: fuelCodes[i] }
            // }),
            optionList: fuelCodeDataList,
            optionKeyGetter: item => item.code,
            optionValueGetter: item => item.code + ' - ' + item.description,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Tertiary Fuel',
            ident: 'tertiaryFuel',
            initialValue: unit.tertiaryFuel,
            // optionList: Object.keys(fuelCodes).map(i => {
            //   return { code: fuelCodes[i] }
            // }),
            optionList: fuelCodeDataList,
            optionKeyGetter: item => item.code,
            optionValueGetter: item => item.code + ' - ' + item.description,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
          })}
        </Col>

        <Col span={4}>
          {getFormSelect({
            label: 'Quarternary Fuel',
            ident: 'quarternaryFuel',
            initialValue: unit.quarternaryFuel,
            // optionList: Object.keys(fuelCodes).map(k => {
            //   return { code: k, display: fuelCodes[k] }
            // }),
            optionList: fuelCodeDataList,
            optionKeyGetter: item => item.code,
            optionValueGetter: item => item.code + ' - ' + item.description,
            updateUnit,
            getFieldDecorator,
            isRequired: false,
          })}
        </Col>
      </Row>
      {showPnodeIds && CLIENT !== NYISO_CLIENT && (
        <Row gutter={12}>
          <Col span={4}>
            {getFormInput({
              label: 'Pnode Id',
              ident: 'pnodeId',
              initialValue: unit.pnodeId,
              updateUnit,
              getFieldDecorator,
              maxLength: 100,
              isRequired: false,
            })}
          </Col>
          <Col span={4}>
            {getFormInput({
              label: 'eMarket Id',
              ident: 'emktId',
              initialValue: unit.emktId,
              updateUnit,
              getFieldDecorator,
              maxLength: 100,
              isRequired: false,
            })}
          </Col>
          <Col span={4}>
            {getFormInput({
              label: 'Rollup eMarket Id',
              ident: 'rollupEmktId',
              initialValue: unit.rollupEmktId,
              updateUnit,
              getFieldDecorator,
              maxLength: 100,
              isRequired: false,
            })}
          </Col>
        </Row>
      )}
      {showPnodeIds && CLIENT === NYISO_CLIENT && (
        <Row gutter={12}>
          <Col span={4}>
            {getFormInput({
              label: 'PTID',
              ident: 'pnodeId',
              initialValue: unit.pnodeId,
              updateUnit,
              getFieldDecorator,
              maxLength: 100,
              isRequired: false,
            })}
          </Col>
          <Col span={4}>
            {getFormInput({
              label: 'Gen ID',
              ident: 'emktId',
              initialValue: unit.emktId,
              updateUnit,
              getFieldDecorator,
              maxLength: 100,
              isRequired: false,
            })}
          </Col>
          <Col span={4}>
            {getFormInput({
              label: 'Spare ID 7',
              ident: 'rollupEmktId',
              initialValue: unit.rollupEmktId,
              updateUnit,
              getFieldDecorator,
              maxLength: 100,
              isRequired: false,
            })}
          </Col>
        </Row>
      )}
    </Form>
  )
}

const mapStateToProps = state => ({
  actionPermits: getPermitActions(state),
})
const UnitModalConnectForm = connect(mapStateToProps)(UnitModalFormGeneral)

export const FormGeneral = Form.create({ name: 'unit_details_General' })(
  UnitModalConnectForm
)
